import { Component, OnInit } from '@angular/core';
import { AuthservicesService } from '../../../services/authservices.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-event-manager',
  templateUrl: './event-manager.component.html',
  styleUrls: ['./event-manager.component.css']
})
export class EventManagerComponent implements OnInit {
  loading = false
  eventArr = []
  totalitems
  objArr = []
  pageSize
  pageNo
  arr = [1, 2, 3, 4]

  constructor(private authService: AuthservicesService, private router: Router) {

    this.pageSize = 10

  }
  ngOnInit(): void {

    this.getAlerts(1);
  }


  getAlerts(event) {
    this.pageNo = event;
    let skip = this.pageSize * (event - 1);
    this.authService.getCommunityEvents(true, skip, this.pageSize).subscribe((res: any) => {
      
      this.eventArr = res.data
      this.totalitems = res.data.length
      console.log('res----q-------->',res);

      this.eventArr?.forEach((e) => {
        this.objArr.push({
          id: (e._id) ? e._id : '',
          name: (e.eventName) ? e.eventName : '',
          description: (e.description) ? e.description : '',
          createdAt: (e.createdAt) ? e.createdAt : '',
          startDate: (e.validFrom) ? e.validFrom : '',
          endDate: (e.validTill) ? e.validTill : '',
          photo: (e.photo) ? e.photo : '',
          city: (e.address.city) ? e.address.city : '',
          streetAddress: (e.address.streetAddress) ? e.address.streetAddress : '',
          state: (e.address.state) ? e.address.state : '',
          country: (e.address.country) ? e.address.country : '',
          followers: (e.followersCount) ? e.followersCount : '0',
          attendees: (e.attendeeCount) ? e.attendeeCount : '0'

        })
      })
      this.loading = true

    },
      error => {
        this.authService.successMessage(error.error.message, 'error')
      })
  }
}
